import { render, staticRenderFns } from "./Technology2.vue?vue&type=template&id=c7021bfe&scoped=true&"
import script from "./Technology2.vue?vue&type=script&lang=js&"
export * from "./Technology2.vue?vue&type=script&lang=js&"
import style0 from "./Technology2.vue?vue&type=style&index=0&id=c7021bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7021bfe",
  null
  
)

export default component.exports